export function gtag(..._: unknown[]) {
  if (typeof window === "undefined" || !window?.dataLayer?.push) return;
  // Must be using 'arguments' & non-arrow function to push the callback into dataLayer
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments as unknown as Record<string, unknown>);
}
